// import React, { useState, useEffect } from "react";
// import { collection, addDoc, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";

// const AddVideoOglyd = () => {
//   const [videoData, setVideoData] = useState({
//     videoName: "",
//     videoDesc: "",
//     ageCategories: [],
//     videoId: "",
//     book_uid: "",
//     bookName: "",
//   });

//   const [books, setBooks] = useState([]);
//   const [ageCategories, setAgeCategories] = useState([]); // 🔹 Список вікових категорій з Firebase
//   const [selectedAges, setSelectedAges] = useState([""]); // 🔹 Масив вибраних категорій

//   useEffect(() => {
//     const fetchBooks = async () => {
//       try {
//         const booksCollection = await getDocs(collection(db, "product"));
//         const booksList = booksCollection.docs.map((doc) => ({
//           uid: doc.id,
//           ...doc.data(),
//         }));
//         setBooks(booksList);
//       } catch (error) {
//         console.error("❌ Помилка отримання книг:", error);
//       }
//     };

//     const fetchAgeCategories = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, "filters"));
//         const filtersData = querySnapshot.docs.map((doc) => doc.data());

//         const ageFilter = filtersData.find(
//           (filter) => filter.transliter === "yearGroup"
//         );

//         if (ageFilter) {
//           setAgeCategories(ageFilter.list);
//         }
//       } catch (error) {
//         console.error("❌ Помилка отримання вікових груп:", error);
//       }
//     };

//     fetchBooks();
//     fetchAgeCategories();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setVideoData({ ...videoData, [name]: value });
//   };

//   // 🟢 **Зміна вікової категорії в конкретному індексі масиву**
//   const handleAgeChange = (index, event) => {
//     const updatedAges = [...selectedAges];
//     updatedAges[index] = event.target.value;
//     setSelectedAges(updatedAges);
//   };

//   // 🟢 **Додавання нової вікової категорії**
//   const addAgeGroup = () => {
//     setSelectedAges([...selectedAges, ""]);
//   };

//   // 🟢 **Видалення вікової категорії**
//   const removeAgeGroup = (index) => {
//     const updatedAges = selectedAges.filter((_, i) => i !== index);
//     setSelectedAges(updatedAges);
//   };

//   const handleUpload = async () => {
//     if (
//       !videoData.videoName ||
//       !videoData.videoDesc ||
//       selectedAges.length === 0
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Заповніть усі поля, включаючи вікові категорії!",
//       });
//       return;
//     }

//     try {
//       const newVideoData = {
//         ...videoData,
//         ageCategories: selectedAges.filter((age) => age !== ""), // 🔹 Видаляємо порожні значення
//       };

//       const docRef = await addDoc(collection(db, "videoV"), newVideoData);
//       console.log("✅ Відео успішно додано до Firebase:", docRef.id);

//       Swal.fire({
//         icon: "success",
//         title: "Успішно",
//         text: "Відео відгук додано!",
//       });

//       setVideoData({
//         videoName: "",
//         videoDesc: "",
//         ageCategories: [],
//         videoId: "",
//         book_uid: "",
//         bookName: "",
//       });
//       setSelectedAges([""]);
//     } catch (error) {
//       console.error("❌ Помилка при додаванні відео:", error);

//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Не вдалося додати відео, спробуйте ще раз.",
//       });
//     }
//   };

//   const handleBookChange = (e) => {
//     const selectedBook = books.find((book) => book.uid === e.target.value);
//     setVideoData({
//       ...videoData,
//       book_uid: selectedBook?.uid || "",
//       bookName: selectedBook?.bookName || "",
//     });
//   };

//   return (
//     <div>
//       <h2>Завантажити відео відгук</h2>

//       <div>
//         <label htmlFor="videoName">Назва відео:</label>
//         <input
//           type="text"
//           id="videoName"
//           name="videoName"
//           value={videoData.videoName}
//           onChange={handleInputChange}
//         />
//       </div>

//       <div>
//         <label htmlFor="videoDesc">Опис відео:</label>
//         <textarea
//           id="videoDesc"
//           name="videoDesc"
//           value={videoData.videoDesc}
//           onChange={handleInputChange}
//         />
//       </div>

//       <div>
//         <p>Вікові категорії:</p>
//         {selectedAges.map((age, index) => (
//           <div
//             key={index}
//             style={{ display: "flex", alignItems: "center", gap: "10px" }}
//           >
//             <select
//               value={age}
//               onChange={(event) => handleAgeChange(index, event)}
//             >
//               <option value="" disabled>
//                 Оберіть вікову категорію
//               </option>
//               {ageCategories.map((category, idx) => (
//                 <option key={idx} value={category}>
//                   {category}
//                 </option>
//               ))}
//             </select>
//             {index > 0 && (
//               <button type="button" onClick={() => removeAgeGroup(index)}>
//                 ❌ Видалити
//               </button>
//             )}
//           </div>
//         ))}
//         <button type="button" onClick={addAgeGroup}>
//           ➕ Додати ще вікову категорію
//         </button>
//       </div>

//       <div>
//         <label htmlFor="videoId">ID відео:</label>
//         <input
//           type="text"
//           id="videoId"
//           name="videoId"
//           value={videoData.videoId}
//           onChange={handleInputChange}
//         />
//       </div>

//       <div>
//         <label htmlFor="bookSelect">Виберіть книгу:</label>
//         <select id="bookSelect" onChange={handleBookChange}>
//           <option value="">Оберіть книгу</option>
//           {books.map((book) => (
//             <option key={book.uid} value={book.uid}>
//               {book.bookName}
//             </option>
//           ))}
//         </select>
//       </div>

//       <button onClick={handleUpload}>Завантажити відео</button>
//     </div>
//   );
// };

// export default AddVideoOglyd;
import React, { useEffect, useMemo, useRef, useState } from "react";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import css from "./AddVideoOglyd.module.css";

const AddVideoOglyd = () => {
  const [videoData, setVideoData] = useState({
    videoName: "",
    videoDesc: "",
    ageCategories: [],
    videoId: "",
    book_uid: "",
    bookName: "",
  });

  const [books, setBooks] = useState([]);
  const [ageCategories, setAgeCategories] = useState([]);
  const [selectedAges, setSelectedAges] = useState([""]);

  const [bookSearch, setBookSearch] = useState("");
  const [isBookListOpen, setIsBookListOpen] = useState(false);
  const [booksLoading, setBooksLoading] = useState(true);

  const bookSearchRef = useRef(null);

  useEffect(() => {
    const fetchBooks = async () => {
      setBooksLoading(true);

      try {
        const booksCollection = await getDocs(collection(db, "product"));

        const booksList = booksCollection.docs.map((document) => ({
          uid: document.id,
          ...document.data(),
        }));

        // Сортування книг за назвою
        booksList.sort((a, b) =>
          String(a.bookName || "").localeCompare(
            String(b.bookName || ""),
            "uk",
          ),
        );

        setBooks(booksList);
      } catch (error) {
        console.error("❌ Помилка отримання книг:", error);

        Swal.fire({
          icon: "error",
          title: "Помилка",
          text: "Не вдалося завантажити список книг.",
        });
      } finally {
        setBooksLoading(false);
      }
    };

    const fetchAgeCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "filters"));

        const filtersData = querySnapshot.docs.map((document) =>
          document.data(),
        );

        const ageFilter = filtersData.find(
          (filter) => filter.transliter === "yearGroup",
        );

        if (ageFilter && Array.isArray(ageFilter.list)) {
          setAgeCategories(ageFilter.list);
        }
      } catch (error) {
        console.error("❌ Помилка отримання вікових груп:", error);
      }
    };

    fetchBooks();
    fetchAgeCategories();
  }, []);

  // Закриваємо список книг при кліку поза блоком пошуку
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        bookSearchRef.current &&
        !bookSearchRef.current.contains(event.target)
      ) {
        setIsBookListOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Фільтруємо книги відповідно до введеного тексту
  const filteredBooks = useMemo(() => {
    const normalizedSearch = bookSearch.trim().toLowerCase();

    const result = normalizedSearch
      ? books.filter((book) =>
          String(book.bookName || "")
            .toLowerCase()
            .includes(normalizedSearch),
        )
      : books;

    // Обмежуємо кількість одночасно показаних книг
    return result.slice(0, 20);
  }, [books, bookSearch]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setVideoData((previousData) => ({
      ...previousData,
      [name]: value,
    }));
  };

  const handleAgeChange = (index, event) => {
    const updatedAges = [...selectedAges];
    updatedAges[index] = event.target.value;

    setSelectedAges(updatedAges);
  };

  const addAgeGroup = () => {
    setSelectedAges((previousAges) => [...previousAges, ""]);
  };

  const removeAgeGroup = (index) => {
    setSelectedAges((previousAges) =>
      previousAges.filter((_, ageIndex) => ageIndex !== index),
    );
  };

  const handleBookSearchChange = (event) => {
    const value = event.target.value;

    setBookSearch(value);
    setIsBookListOpen(true);

    // Якщо користувач почав редагувати поле після вибору,
    // скидаємо попередньо вибрану книгу
    setVideoData((previousData) => ({
      ...previousData,
      book_uid: "",
      bookName: "",
    }));
  };

  const handleBookSelect = (book) => {
    const bookName = book.bookName || "";

    setVideoData((previousData) => ({
      ...previousData,
      book_uid: book.uid,
      bookName,
    }));

    setBookSearch(bookName);
    setIsBookListOpen(false);
  };

  const clearSelectedBook = () => {
    setBookSearch("");

    setVideoData((previousData) => ({
      ...previousData,
      book_uid: "",
      bookName: "",
    }));

    setIsBookListOpen(true);
  };

  const handleUpload = async () => {
    const validAgeCategories = selectedAges.filter(
      (age) => age && age.trim() !== "",
    );

    if (
      !videoData.videoName.trim() ||
      !videoData.videoDesc.trim() ||
      validAgeCategories.length === 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть назву, опис і хоча б одну вікову категорію.",
      });

      return;
    }

    try {
      const newVideoData = {
        ...videoData,
        videoName: videoData.videoName.trim(),
        videoDesc: videoData.videoDesc.trim(),
        videoId: videoData.videoId.trim(),
        ageCategories: validAgeCategories,
      };

      const docRef = await addDoc(collection(db, "videoV"), newVideoData);

      console.log("✅ Відео успішно додано до Firebase:", docRef.id);

      await Swal.fire({
        icon: "success",
        title: "Успішно",
        text: "Відеоогляд додано!",
      });

      setVideoData({
        videoName: "",
        videoDesc: "",
        ageCategories: [],
        videoId: "",
        book_uid: "",
        bookName: "",
      });

      setSelectedAges([""]);
      setBookSearch("");
      setIsBookListOpen(false);
    } catch (error) {
      console.error("❌ Помилка при додаванні відео:", error);

      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося додати відео. Спробуйте ще раз.",
      });
    }
  };

  return (
    <div className={css.page}>
      <div className={css.container}>
        <div className={css.header}>
          <h2 className={css.title}>Додати відеоогляд</h2>

          <p className={css.subtitle}>
            Заповніть інформацію про відео та за потреби прив’яжіть його до
            книги.
          </p>
        </div>

        <div className={css.form}>
          <div className={css.formGroup}>
            <label className={css.label} htmlFor="videoName">
              Назва відео
            </label>

            <input
              className={css.input}
              type="text"
              id="videoName"
              name="videoName"
              value={videoData.videoName}
              onChange={handleInputChange}
              placeholder="Наприклад: Відеоогляд книги"
            />
          </div>

          <div className={css.formGroup}>
            <label className={css.label} htmlFor="videoDesc">
              Опис відео
            </label>

            <textarea
              className={css.textarea}
              id="videoDesc"
              name="videoDesc"
              value={videoData.videoDesc}
              onChange={handleInputChange}
              placeholder="Введіть короткий опис відео"
            />
          </div>

          <div className={css.formGroup}>
            <span className={css.label}>Вікові категорії</span>

            <div className={css.ageList}>
              {selectedAges.map((age, index) => (
                <div className={css.ageRow} key={index}>
                  <select
                    className={css.select}
                    value={age}
                    onChange={(event) => handleAgeChange(index, event)}
                  >
                    <option value="" disabled>
                      Оберіть вікову категорію
                    </option>

                    {ageCategories.map((category, categoryIndex) => (
                      <option
                        key={`${category}-${categoryIndex}`}
                        value={category}
                      >
                        {category}
                      </option>
                    ))}
                  </select>

                  {index > 0 && (
                    <button
                      className={css.removeButton}
                      type="button"
                      onClick={() => removeAgeGroup(index)}
                    >
                      Видалити
                    </button>
                  )}
                </div>
              ))}
            </div>

            <button
              className={css.addButton}
              type="button"
              onClick={addAgeGroup}
            >
              + Додати вікову категорію
            </button>
          </div>

          <div className={css.formGroup}>
            <label className={css.label} htmlFor="videoId">
              ID відео
            </label>

            <input
              className={css.input}
              type="text"
              id="videoId"
              name="videoId"
              value={videoData.videoId}
              onChange={handleInputChange}
              placeholder="Наприклад: dQw4w9WgXcQ"
            />

            <span className={css.hint}>
              Вкажіть ID відео, а не повне посилання.
            </span>
          </div>

          <div className={css.formGroup}>
            <label className={css.label} htmlFor="bookSearch">
              Книга
            </label>

            <div className={css.bookSearch} ref={bookSearchRef}>
              <div className={css.searchInputWrapper}>
                <input
                  className={`${css.input} ${css.searchInput}`}
                  type="text"
                  id="bookSearch"
                  value={bookSearch}
                  onChange={handleBookSearchChange}
                  onFocus={() => setIsBookListOpen(true)}
                  placeholder="Почніть вводити назву книги"
                  autoComplete="off"
                  role="combobox"
                  aria-expanded={isBookListOpen}
                  aria-controls="book-search-results"
                />

                {bookSearch && (
                  <button
                    className={css.clearButton}
                    type="button"
                    onClick={clearSelectedBook}
                    aria-label="Очистити вибрану книгу"
                  >
                    ×
                  </button>
                )}
              </div>

              {isBookListOpen && (
                <div className={css.bookDropdown} id="book-search-results">
                  {booksLoading ? (
                    <div className={css.dropdownMessage}>
                      Завантаження книг...
                    </div>
                  ) : filteredBooks.length > 0 ? (
                    filteredBooks.map((book) => (
                      <button
                        className={`${css.bookOption} ${
                          videoData.book_uid === book.uid
                            ? css.activeBookOption
                            : ""
                        }`}
                        type="button"
                        key={book.uid}
                        onClick={() => handleBookSelect(book)}
                      >
                        <span className={css.bookOptionName}>
                          {book.bookName || "Книга без назви"}
                        </span>

                        {book.author && (
                          <span className={css.bookOptionMeta}>
                            {book.author}
                          </span>
                        )}
                      </button>
                    ))
                  ) : (
                    <div className={css.dropdownMessage}>
                      Книг за цим запитом не знайдено
                    </div>
                  )}

                  {!booksLoading && filteredBooks.length === 20 && (
                    <div className={css.dropdownHint}>
                      Введіть точнішу назву, щоб звузити результати.
                    </div>
                  )}
                </div>
              )}
            </div>

            {videoData.book_uid && (
              <div className={css.selectedBook}>
                <span>Вибрана книга:</span>
                <strong>{videoData.bookName}</strong>
              </div>
            )}
          </div>

          <button
            className={css.submitButton}
            type="button"
            onClick={handleUpload}
          >
            Завантажити відео
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddVideoOglyd;
